import LearnMoreAboutOCIActivatedModal from './LearnMoreAboutOCIActivatedModal';

export default LearnMoreAboutOCIActivatedModal;
